import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  const footerSections = [
    {
      title: 'Company',
      links: [
        { text: 'About Us', href: 'https://metroblue.com.ng/aboutmetroblue' },
        { text: 'Contact Us', href: 'https://metroblue.com.ng/contactus' },
        { text: 'Our Careers', href: 'https://metroblue.com.ng/careers' },
        { text: 'Job Application', href: 'https://metroblue.com.ng/careers' }
      ]
    },
    {
      title: 'Services',
      links: [
        { text: 'Graphics', href: 'https://metroblue.com.ng/graphics' },
        { text: 'Software App', href: 'https://metroblue.com.ng/software' },
        { text: 'Digital Marketing', href: 'https://metroblue.com.ng/digitalmarketing' },
        { text: 'Web Development', href: 'https://metroblue.com.ng/website' }
      ]
    },
    {
      title: 'Solutions',
      links: [
        { text: 'Educesol', href: 'https://metroblue.com.ng/educesol' },
        { text: 'Enterprise', href: 'https://metroblue.com.ng/enterprise' },
        { text: 'Metroblits', href: 'https://metroblue.com.ng/metroblits' },
        { text: 'Custom Solutions', href: 'https://metroblue.com.ng/customsolutions' }
      ]
    },
    {
      title: 'Training',
      links: [
        { text: 'Mobile App', href: 'https://metroblue.com.ng/traininginfo' },
        { text: 'Desktop App', href: 'https://metroblue.com.ng/traininginfo' },
        { text: 'Web Development', href: 'https://metroblue.com.ng/traininginfo' },
        { text: 'Digital Marketing', href: 'https://metroblue.com.ng/traininginfo' }
      ]
    }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {footerSections.map((section, index) => (
            <div key={index} className="footer-section">
              <h4 className="footer-title">{section.title}</h4>
              <div className="footer-links">
                {section.links.map((link, linkIndex) => (
                  <a key={linkIndex} href={link.href} className="footer-link">
                    {link.text}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        <div className="footer-bottom">
          <hr className="footer-divider" />
          <p className="footer-copyright">
            &copy; 2019 - 2025 | MetroBlue Tech Systems Ltd., All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;